/**
 *Created by jmmartinez on 30/10/20
 * v 1.1  20/10/2020 Añadido CAMPOTIPO_LISTA_CHECKS
 * v 1.2  04/03/2021 Añadido CAMPOTIPO_COMBOIMPRESORAS
 * v 1.3  30/03/2022 Añadido CAMPOTIPO_COMPONENTE
 * v 1.4  28/04/2022 Añadido CAMPOTIPO_CADENAACCION
 * v 1.5  01/07/2022 Añadido CAMPOTIPO_OPCIONES_CLAVENONUMERICA
 * **/


export const CAMPOTIPO_NODEFINIDO = 0;
export const CAMPOTIPO_CADENA = 'CADENA';
export const CAMPOTIPO_BOOLEANO = 'BOOLEANO';
export const CAMPOTIPO_CHECK = 'CHECK';
export const CAMPOTIPO_COMBO = 'COMBO';
export const CAMPOTIPO_COMBOENUM = 'COMBOENUM';
export const CAMPOTIPO_RADIO = 'RADIO';
export const CAMPOTIPO_FECHA = 'FECHA';
export const CAMPOTIPO_FECHAHORA = 'FECHAHORA';
export const CAMPOTIPO_IMAGENURL = 'IMAGENURL';
export const CAMPOTIPO_IMAGENURLUPLOADER = 'IMAGENURLUPLOADER';
export const CAMPOTIPO_FECHAPERIODO = 'FECHAPERIODO';
export const CAMPOTIPO_COLOR = 'COLOR';
export const CAMPOTIPO_HORA = 'HORA';
export const CAMPOTIPO_ENTERO = 'ENTERO';
export const CAMPOTIPO_IMAGENLISTA = 'IMAGENLISTA';
export const CAMPOTIPO_OPCIONES= 'OPCIONES';
export const CAMPOTIPO_FLOTANTE = 'FLOTANTE';
export const CAMPOTIPO_MONEDA = 'MONEDA';
export const CAMPOTIPO_FECHAACTIVABLE= 'FECHAACTIVABLE';
export const CAMPOTIPO_PORCENTAJE = 'PORCENTAJE';
//export const CAMPOTIPO_ICONOACCION= 'ICONOACCION';
//export const CAMPOTIPO_BOTONACCION= 'BOTONACCION';
export const CAMPOTIPO_COMBOOBJETOS= "COMBOOBJETOS";
export const CAMPOTIPO_MEMO= "MEMO";
export const CAMPOTIPO_LABEL= "LABEL";
export const CAMPOTIPO_LISTACHECKS= "LISTACHECKS";
export const CAMPOTIPO_COMBOIMPRESORAS= "COMBOIMPRESORAS";
export const CAMPOTIPO_SELECTORDOCUMENTOS= "SELECTORDOCUMENTOS";
export const CAMPOTIPO_CADENAACCION = 'CADENAACCION';
export const CAMPOTIPO_FECHACADENA = 'CAMPOTIPO_FECHACADENA';
export const CAMPOTIPO_FECHAHORACADENA= 'CAMPOTIPO_FECHAHORACADENA';
export const CAMPOTIPO_OPCIONES_CLAVENONUMERICA= 'CAMPOTIPO_OPCIONES_CLAVENONUMERICA';

export const CAMPOTIPO_HTMLMEMO= 'CAMPOTIPO_HTMLMEMO';
export const CAMPOTIPO_FIRMAMAIL= 'CAMPOTIPO_FIRMAMAIL';